import React, {useEffect, useState} from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import {Helper} from "../../../tools/Helper";
import {api_Routes} from "../../../tools/api_Routes";
import {useParams} from "react-router-dom";
import {CircularProgress, LinearProgress} from "@mui/material";
import {FormEditCategory} from "./FormEditCategory";

export const PanelEditEmailProvider = () => {
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState({
        name: "",
        driver: "",
        host: "",
        port: 0,
        username: "",
        password: "",
        encryption: "",
        from_address: "",
        from_name: "",
        priority: 0,
        daily_limit: 0,
        monthly_limit: 0,
        is_active: 0,
    });
    const getData = async () => {
        try {
            const {result, response} = await Helper.Get({
                url: `${api_Routes.EmailProviders.View}/${id}`,
            });

            if (response) {
                setData({
                    name: response.data.name || "",
                    driver: response.data.driver || "",
                    host: response.data.credentials.host || "",
                    port: response.data.credentials.port || 0,
                    username: response.data.credentials.username || "",
                    password: response.data.credentials.password || "",
                    from_address: response.data.from_address|| "",
                    from_name: response.data.from_name || "",
                    encryption: response.data.credentials.encryption || "",
                    priority: response.data.priority || 0,
                    daily_limit: response.data.daily_limit || 0,
                    monthly_limit: response.data.monthly_limit || 0,
                    is_active:response.data.is_active ? 1 : 0 || 0,
                });
            }
        } catch (error) {
            console.error("Error fetching details:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <div>
            {" "}
            <PanelHead
                title={
                    isLoading ? (
                        <div className="flex items-center gap-4">
                            Edit Email Provider <CircularProgress size={24}/>
                        </div>
                    ) : (
                        <div className="flex items-center justify-between w-full gap-4">
                            <div>Edit Email Provider: {data?.name}</div>
                        </div>
                    )
                }
            />
            <PanelBody
                content={
                    isLoading ? (
                        <LinearProgress/>
                    ) : (
                        <FormEditCategory data={data} setData={setData}/>
                    )
                }
            />
        </div>
    );
};
